import { StyleSheet } from 'aphrodite';

export const styleSheet = StyleSheet.create({
	logo: {
		height: '100%',
		objectFit: 'contain',
		width: '100%',
	},
});
